module.exports = __webpack_public_path__ + "static/Logo-001c3f9331d429ad83e1f121451b2544.png";